import type { CardBadge } from './CardBadge';

/**
 * The chips a card's row draws, in order.
 *
 * While there IS something to do, the flashcards chip reads primary
 * (Figma 5868:74033) — in EVERY view, so a grid card whose corner carries the
 * to-do chip matches its list row. The first ACTIVITY chip is the flashcards
 * slot by the `studyActivityBadges` contract; a `leading` chip (a set's
 * files) stands ahead of it and is never the one promoted. The promotion is
 * decided BEFORE the zero-count chips are dropped, so a hidden flashcards
 * chip cannot hand it to its neighbour.
 */
export function visibleCardChips(
  badges: readonly CardBadge[] | undefined,
  hasTodo: boolean,
): CardBadge[] {
  const all = badges ?? [];
  const flashcardsAt = all.findIndex((badge) => !badge.leading);
  return all
    .map((badge, i) =>
      hasTodo && i === flashcardsAt ? { ...badge, colour: 'primary' as const } : badge,
    )
    .filter((badge) => badge.count !== 0);
}
